import {
  HOUSE_KEEPING_ROOM_CONTROL_REPORT_CLOSE_DAY,
  HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL,
  HOUSE_KEEPING_ROOM_STATE_REPORT_UPDATE,
} from '@constants/ApiEndpoints/HouseKeepingRootEndpoint';
import { AxiosInstance } from 'axios';
import { FilterMenuModel } from 'pages/HouseKeepingModule/pages/HouseKeepingReportPage/models/FilterMenuModel';
import {
  HouseKeepingRoomStateFormModel,
  RoomControlTypeEnum,
  RoomStatusListModel,
} from 'pages/HouseKeepingModule/pages/HouseKeepingReportPage/models/RoomStatusModel';
import { getExportConfig, handleFileExport } from '../../../pages/ReportModule/helpers/fileExport';
import { exportFileTypes } from '../../../pages/ReportModule/models/exportFileTypes';

export type Params = {
  search?: string;
  limit?: number;
  offset?: number;
};

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: {
      room_number?: string | undefined;
      limit?: number;
      offset?: number;
    } & Partial<FilterMenuModel>
  ): Promise<RoomStatusListModel> =>
    await axios.get(HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL, { params }).then(({ data }) => data);

export const exportPDF =
  (axios: AxiosInstance) =>
  async (
    params?: {
      room_number?: string | null | undefined;
      limit?: number;
      offset?: number;
      from: string;
      to: string;
    } & Partial<FilterMenuModel> & {
        file_type: exportFileTypes;
        autoPrint?: boolean;
        send?: boolean;
      }
  ): Promise<void> => {
    const { autoPrint, send, ...requestParams } = params || {};

    return await axios
      .get(`${HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL}`, {
        params: { ...requestParams },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'room-service-status-report',
          autoPrint,
          send,
        });
      });
  };

export const update =
  (axios: AxiosInstance) =>
  async (
    data: Partial<HouseKeepingRoomStateFormModel>
  ): Promise<{
    data: any;
    status: number;
    non_traited_period: {
      from: string;
      to: string;
      maintenance_type_id: number;
      comment: string;
      room_id: number;
    }[];
  }> => {
    return await axios
      .post(HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL, data)
      .then(({ data }) => data?.items);
  };

export const roomControl =
  (axios: AxiosInstance) =>
  async (data: {
    room_id: number;
    adults: number;
    children: number;
    inf: number;
    comment: string;
    type: RoomControlTypeEnum | null;
  }): Promise<{
    data: any;
    status: number;
  }> => {
    return await axios.post(HOUSE_KEEPING_ROOM_STATE_REPORT_UPDATE, data).then(({ data }) => data);
  };

export const closeDay =
  (axios: AxiosInstance) =>
  async (): Promise<{
    data: any;
    status: number;
  }> => {
    return await axios
      .patch(HOUSE_KEEPING_ROOM_CONTROL_REPORT_CLOSE_DAY)
      .then(response => response.data);
  };
